import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bsdrop-down',
	templateUrl:'./BSDropDownPluginCompPage.html',
	styles: [],
	styleUrls:['./BSDropDownPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSDropDownPluginCompPage
{
	mdContent_812 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.dropdown.BSDropDown;
\`\`\``;
	mdContent_813 = `\`\`\`java
BSDropDown()
\`\`\``;
	mdContent_814 = `\`\`\`java
BSDropDown&lt;?&gt; dd = new BSDropDown&lt;&gt;();
dd.setText("Actions");
dd.addItem("Edit");
dd.addItem("Delete");
dd.setPlacement(BSPlacements.BottomEnd);
\`\`\``;
}
